export default __webpack_public_path__ + "932882bd227dfaa43a085820057aad68.png";